module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOSIgaGVpZ2h0PSI1IiB2aWV3Qm94PSIwIDAgOSA1IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPg0KPHBhdGggZD0iTTAuNSAwLjVMNC4xNzA3NSAzLjcxMTlDNC4zNTkyNiAzLjg3Njg1IDQuNjQwNzQgMy44NzY4NSA0LjgyOTI1IDMuNzExOUw4LjUgMC41IiBzdHJva2U9IiM0NTk3RjgiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPg0KPC9zdmc+DQo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/expand.svg
// module id = 74sF
// module chunks = 1